import React, { useEffect, useState, useCallback, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import FlatFileUpload from 'components/sales/bulkUpload/FlatFileUpload';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import ModalPop from "components/sales/modal/modal";

const BrandActivation = ({
  getSiteListing,
  siteListData,
  getSiteFilters,
  siteFilters,
  UploadFlat,
  history,
}) => {
  const headers = [
    'Site Number',
    'Infra Project ID',
    'Site Type',
    'Client Name',
    'Assigned To',
    'Onboarded Date',
    'Contract Live Date',
    'Contract Expiry Date',
    'Site Status',
    'Download Flats',
    // 'File Status',
    'Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isbulk, setIsbulk] = useState(false);
  const [isUploaded, setIsuploaded] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const { baseUrl } = useContext(BaseUrl);
  const [role, setRole] = useState('');
  const [fileUrls, setFileUrls] = useState([]);
  const [isModal, setIsModal] = useState(false);

  const sampleData = {
    file_url: fileUrl,
    // 'https://parkqa.kelltontech.net/download_sample/Flat_List_Format.xls',
  };
  
  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("baSiteCont") &&
        localStorage.getItem("baSiteCont")
    );
    if(installationCont){
      localStorage.setItem("baSiteList", JSON.stringify(""));
      localStorage.setItem("baSiteCont", 0);
    }

    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'));
        roles && setRole(roles[0].pivot.role_id);
      })();
    }, 0);

  }, []);

  const getList = useCallback(async () => {
    setIsLoading(true);
    const getcontractFilter = await JSON.parse(
      localStorage.getItem("baSiteList") &&
        localStorage.getItem("baSiteList")
    );
    setIsLoading(true);
    if(getcontractFilter){
      await getSiteListing(getcontractFilter);
    }else{
      await getSiteListing();
    }
    // await getSiteListing(null, currentPage);
    setIsLoading(false);

  }, [getSiteListing, currentPage]);

  useEffect(() => {
    if (getSiteListing !== null) getList();
  }, [getSiteListing, getList]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSiteFilters();
      setIsLoading(false);
    })();
  }, [getSiteFilters]);

  useEffect(() => {
    const actions = [
      {
        name: 'View Details',
        link: '/dashboard/brand-activation/site-details',
      },
      { name: "View Poc's", link: '/dashboard/brand-activation/viewPoc' },
      {
        name: 'Site Stages',
        link: '/dashboard/site-stage',
      },
      /* {
        name: 'Conduct Camp',
        link: '/dashboard/brand-activation/conduct-camp/camp',
      }, */
      /* {
        name: 'Conduct Carnival',
        link: '/dashboard/brand-activation/conduct-carnival/carnival',
      }, */
      // {
      //   name: 'Change Assignee',
      //   link: '/dashboard/brand-activation/change-assignee',
      // },
      { name: 'Service PR', link: '/dashboard/vendor-allocation/3' },
      // {
      //   name: 'Update POC',
      //   link: '/dashboard/brand-activation/edit-contract-poc',
      // },
      // {
      //   name: 'Renew Contract',
      //   link: '/dashboard/brand-activation/renew-contract',
      // },
      { name: 'Return Tag', link: '/dashboard/return-tag' },
    ];

    const actions1 = [
      {
        name: 'View Details',
        link: '/dashboard/brand-activation/site-details',
      },
      { name: "View Poc's", link: '/dashboard/brand-activation/viewPoc' },
      {
        name: 'Site Stages',
        link: '/dashboard/site-stage',
      },
      // {
      //   name: 'Meeting Tracker',
      //   link: '/dashboard/brand-activation/scheduled-meetings',
      // },
      /* {
        name: 'Conduct Camp',
        link: '/dashboard/brand-activation/conduct-camp/camp',
      }, */
      {
        name: 'Manage Corporate Client',
        link: '/dashboard/brand-activation/corporate-list',
      },
      /* {
        name: 'Conduct Carnival',
        link: '/dashboard/brand-activation/conduct-carnival/carnival',
      }, */
      // {
      //   name: 'Change Assignee',
      //   link: '/dashboard/brand-activation/change-assignee',
      // },
      { name: 'Return Tag', link: '/dashboard/return-tag' },
      { name: 'Service PR', link: '/dashboard/vendor-allocation/3' }
    ];

    // const actionDismantle = [
    //   {
    //     name: 'View Details',
    //     link: '/dashboard/brand-activation/site-details',
    //   }
    // ];
    const tableData = [
      'site_id',
      'site_no',
      'infra_project_id',
      'lead_id',
      'site_type',
      'client_name',
      'assigned_to',
      'created_at',
      'live_date',
      'expiry_date',
      // 'FileUploaded',
      'status_name',
      'download_flats',
    ];
    if (siteListData && siteListData.resultSets) {
      const data = siteListData.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => (
            (key === 'download_flats' && element.flat_file_status == 1) ? 
                        {[key]: 'Yes'} : {[key]: element[key]} 
          )),
          {
            // FileUploaded:
            //   element.flat_file_status === 0 ? 'Not Uploaded' : 'Uploaded',
            Status: element.status,
            Action:
              element.site_type === 'Corporate'
                ? [
                  ...actions1,
                  (element.site_status !== 4) && {
                    name: 'Change Assignee',
                    link: '/dashboard/brand-activation/change-assignee',
                  },
                  ...((element.site_status == 2 || element.site_status == 3 || element.site_status == 21 || element.site_status == 26 || element.site_status == 16 || element.site_status == 4)
                    ? [{
                      name: 'Renew Contract',
                      link: '/dashboard/brand-activation/renew-contract',
                    }]
                    : []),
                  {
                    name:'Upload Flat File',
                    link: '',
                  },
                  // {
                  //   name:
                  //     element.flat_file_status === 1
                  //       ? 'Download Flat File'
                  //       : null,
                  //   link: '',
                  //   url: element.flat_file_url,
                  // },
                ]
                : element.site_type === 'Apartment'
                ? [
                    ...actions,
                    (element.site_status !== 4) && {
                      name: 'Change Assignee',
                      link: '/dashboard/brand-activation/change-assignee',
                    },
                    ...((element.site_status == 2 || element.site_status == 3 || element.site_status == 21 || element.site_status == 26 || element.site_status == 16 || element.site_status == 4)
                      ? [{
                        name: 'Renew Contract',
                        link: '/dashboard/brand-activation/renew-contract',
                      }]
                      : []),
                    {
                      name:'Upload Flat File',
                      link: '',
                    },
                    // {
                    //   name:
                    //     element.flat_file_status === 1
                    //       ? 'Download Flat File'
                    //       : null,
                    //   link: '',
                    //   url: element.flat_file_url,
                    // },
                  ]
                  /* [
                    ...actions,
                    {
                      name:
                        element.flat_file_status === 0
                          ? 'Upload Flat File'
                          : 'Download Flat File',
                      link: '',
                      url: element.flat_file_url,
                    },
                  ] */
                : [
                    ...actions,
                    (element.site_status !== 4) && {
                      name: 'Change Assignee',
                      link: '/dashboard/brand-activation/change-assignee',
                    },
                    ...((element.site_status == 2 || element.site_status == 3 || element.site_status == 21 || element.site_status == 26 || element.site_status == 16 || element.site_status == 4)
                      ? [{
                        name: 'Renew Contract',
                        link: '/dashboard/brand-activation/renew-contract',
                      }]
                      : []),
                  ],
          }
        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          obj['manage_id'] = obj['lead_id'];
          delete obj['lead_id'];
          obj['id'] = obj['site_id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });
        newData && setListData(newData);
      }
      setPageCount(Math.ceil(siteListData.total / siteListData.per_page));
    }
  }, [siteListData]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("baSiteList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getSiteListing(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };
  
  const handleDownloadFlatFiles = async (siteNo) => {
    if(siteNo) {
      const url = `${Config.brandActivation.getFlatFiles}?site_no=${siteNo}`;
      const res  = await axios.get(url);
      //console.log(JSON.stringify(res));
      if(res && res.data.response) {
          setIsLoading(true);
          setFileUrls(res?.data?.response.data);
          setIsModal(true);
          setIsLoading(false);
      }
    } else {
      return false;
    }
  }
  
  const handleModalHide = () => {
    setIsModal(false);
  };

  const redirectToBulkAssignment = () => {
    history.push(`${baseUrl}/bulk-assignment?type=baSiteList`);
  }

  const headerBtns = () => {
    return (
        <>
          {role !== 9 &&
              <Button
              onClick={redirectToBulkAssignment}
              className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
          >
            <img src={Images?.Filter} alt="" />
            <b className="site_filters" style={{width:"max-content"}}>
              {localization.bulkAssignment}
            </b>
          </Button>
          }
          <Button
              onClick={filterToggle}
              className="filter-hamburger btn btn-transparent"
          >
            <img src={Images.Filter} alt="" />
            {localization.showFilters}
          </Button>
        </>
    );
  };

  // const onPageChange = async (val) => {
  //   // let filter = filterData === null ? null : filterData;
  //   setCurrentPage(val.selected + 1);
  //   // setIsLoading(true);
  //   await getSiteListing(filter, val.selected + 1);
  //   // setIsLoading(false);
  // };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getSiteListing(filterData, val.selected + 1);
    // let filter = filterData === null ? null : filterData;
    setIsLoading(false);
  };

  const handlebulkSubmit = async () => {
    if (bulkFile !== null) {
      const res = await UploadFlat({
        base_64_file: `${bulkFile}`,
        site_id: isbulk,
      });
      if (res) {
        setIsuploaded(true);
      } else {
        setIsuploaded(false);
      }
    }
  };

  const handleFileChange = (val) => setBulkFile(val);
console.log(listData);
  return (
    <Layout
      title={localization.brandActivation}
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      <TableSection
        data={listData}
        isId={false}
        isMngId={false}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        detailList={siteListData && siteListData.resultSets}
        setIsbulk={setIsbulk}
        setFileUrl={setFileUrl}
        srNo={siteListData?.from}
        handleDownloadFlatFiles={handleDownloadFlatFiles}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={siteFilters?.site_types ? siteFilters : null}
        siteFilters
      />
      <FlatFileUpload
        sampleData={sampleData && sampleData}
        handleModalHide={() => {
          setIsbulk(false);
          setIsuploaded(false);
        }}
        handlebulkSubmit={handlebulkSubmit}
        isbulk={isbulk}
        getList={getList}
        handleFileChange={handleFileChange}
        isUploaded={isUploaded}
        redirectUrl={`/brand-activation/sites-listing`}
        redirectName={localization.siteListingView}
      />
      <ModalPop
            title={localization.downloadFlats}
            show={isModal}
            handleModalHide={handleModalHide}
            keyboard
          >
          <div className="row">
            {fileUrls && fileUrls?.length > 0 ? (
              <>
              {fileUrls.map((url,i) => {
                return (
                  <div className="col-md-3" key={i}>
                   <a className="btn btn-primary w-auto ml-2" href={url} download>
                    {`Download File ` + (i+1)}
                   </a>
                  </div>
                )
              }
              )}
              </>
           ):null}
          </div>
      </ModalPop>
    </Layout>
  );
};

export default BrandActivation;
